import styled from "styled-components/macro";

import { MixinPlace } from "../mixins";

export const ContainerDiv = styled.div`
  position: relative;
  max-width: 380px;
  width: 100%;
  justify-self: flex-start;
`;

export const StyledButton = styled.div`
  ${MixinPlace};
  width: max-content;

  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  background-color: ${(props) => props.theme.colors.secondary};
  cursor: pointer;
  color: ${(props) => props.theme.colors.textMuted};
`;

export const PopupSelect = styled.div`
  position: absolute;
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.place};
  color: ${(props) => props.theme.colors.text};
  opacity: 0;
  transition: 0.7s;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  &.active {
    opacity: 1;
  }
  left: 0;
  width: 100%;
  z-index: 40;
  top: calc(100% + 0.2em);
  padding: 16px 16px 0 16px;
  & > p {
    font-size: 16px;
    margin: 0;
    padding-bottom: 16px;

    line-height: 133%;
  }
`;
